<template>
  <div class="studentDisplay">
    <div class="stu-search">
      <el-form ref="form" :inline="true" class="demo-form-inline">
        <!-- 查询输入框 -->
        <el-form-item v-show="tab_pane_index!=4">
          <div class="search-text" style="width:300px">
            <el-input placeholder="请输入关键字查询" v-model="search_data.mc" class="input-with-select">
            </el-input>
          </div>
        </el-form-item>
        <el-form-item class="fr" v-show="tab_pane_index!=4">
          <el-button icon="el-icon-search" type="primary" class="fl tea-btn" @click="handelSearchAll(search_data.bjmc)">
            查 询
          </el-button>
        </el-form-item>
      </el-form>
      <div class="stu-add" style="padding-bottom:20px">
        <el-button icon="el-icon-folder-add" type="primary" class="fr tea-btn" @click="addGroup()"
                   :disabled='class_type==1' v-show="tab_pane_index=='2'">创建小组
        </el-button>
        <el-button icon="el-icon-user-solid" type="primary" class="fr tea-btn" @click="randomGroup()"
                   :disabled='class_type==1' v-show="tab_pane_index=='2'">学生随机分组
        </el-button>
        <el-button icon="el-icon-message-solid" type="primary" class="fr tea-btn" @click="classBegin()"
                   v-show="tab_pane_index=='4'&&class_type!=1">上 课
        </el-button>
        <el-button icon="el-icon-video-play" type="primary" class="fr tea-btn" @click="suspend"
                   v-show="tab_pane_index=='4'&&suspendShow && class_type==1 ">暂停
        </el-button>
        <el-button icon="el-icon-video-pause" type="primary" class="fr tea-btn" @click="start"
                   v-show="tab_pane_index=='4'&&startShow && class_type==1">开始
        </el-button>
        <el-button icon="el-icon-bell" type="primary" class="fr tea-btn" @click="classEnd()"
                   v-show="tab_pane_index=='4'&&class_type==1">下 课
        </el-button>

        <el-button icon="el-icon-present" type="primary" class="fr tea-btn" @click="exchange()"
                   v-show="tab_pane_index=='4'&&class_type!=1">
          {{ exchangeFlag ? '结束兑换' : '开始兑换' }}
        </el-button>
      </div>
    </div>
    <div class="class-box">
      <el-tabs type="border-card" v-model="tab_pane_index" @tab-click='tabClick()'>
        <el-tab-pane label="学生列表" name="1">
          <div class="table">
            <el-table stripe border :data="tableData" height="calc(100% - 40px)">
              <el-table-column prop="index" label="序号" align="center"/>
              <el-table-column prop="yhm" label="登陆账号" align="center"/>
              <el-table-column prop="xm" label="姓名" align="center"/>
              <el-table-column prop="yhid" label="学生编号" align="center"/>
              <!-- <el-table-column prop="xjh" label="学籍号" align="center" /> -->
              <el-table-column prop="Gender" label="性别" align="center"/>
              <el-table-column prop="bzrsjh" label="备注" align="center"/>
            </el-table>
            <div class="tea-pagination">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                             :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]"
                             :page-size="pages.pageSize" layout="total, sizes, prev, pager, next, jumper"
                             :total="pages.total">
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="分组管理" name="2" v-if="ywjx==1">
          <div class="stu-group">
            <group :tab_pane_index='2' :class_type='class_type' ref="group" @groupNumChange='groupNumChange'></group>
          </div>
        </el-tab-pane>
        <el-tab-pane label="历史分组管理" name="3" v-if="ywjx==1">
          <div class="stu-group">
            <group :tab_pane_index='3' ref="historyGroup"></group>
          </div>
        </el-tab-pane>
        <el-tab-pane label="课程安排" name="4" v-if="ywjx==1">
          <div class="stu-group">
            <course></course>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
// import $bus
import {
  exchangeInquiry, modifyExchange,
  getStudentLisTemporarytApi, getStudentRoutineList, startClassApi,//上课
  endClassApi, lockChangeApi//下课
} from '@/api/teacher'


export default {
  components: {
    group: (resolve) => {
      require(["@/components/teacher/class/group.vue"], resolve);
    },
    course: (resolve) => {
      require(["@/components/teacher/class/course.vue"], resolve);
    },
  },
  data() {
    return {
      suspendShow: JSON.parse(localStorage.getItem('suspendShow')) || false,
      startShow: JSON.parse(localStorage.getItem('startShow')) || false,
      is_socket: 0,
      group_num: '',
      class_type: 1,//1上课中 0未上课 2已下课
      yhid: this.$store.state.userInfo.yhid,
      zhid: this.$store.state.userInfo.zhid,
      ywjx: this.$route.query.ywjx,
      search_data: {
        bjmc: null
      },
      tab_pane_index: '1',
      tableData: [],
      params: {},
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      bjid: '',
      bjlx: '',
      bjmc: '',
      exchangeFlag: false
      // 分组
    }
  },
  created() {
    console.log(this.$store.state.is_socket)
    this.is_socket = this.$store.state.is_socket
  },
  watch: {
    '$store.state.is_socket': function () {
      this.is_socket = this.$store.state.is_socket
      console.log(this.$store.state.is_socket)
    },
  },
  mounted() {
    this.$emit('change-top', [
      {title: '首页', pathName: '/myClass'},
      {title: '我的班级', pathName: '/myClass'},
      {title: '班级学生', pathName: ''},
    ])
    this.bjlx = this.$route.query.lx
    this.bjid = this.$route.query.classId
    this.bjmc = this.$route.query.bjmc,
        this.class_type = this.$route.query.class_type,
        this.getStudentListApiFun()
    this.queryExchange()
  },
  methods: {


    groupNumChange(val) {
      this.group_num = val
    },
    handleSizeChange(val) {
      this.pages.currentPage = 1;
      this.pages.pageSize = val;
      this.getStudentListApiFun()
    },
    //  -------------------------------------分页器
    handleCurrentChange(val) {
      this.pages.currentPage = val;
      this.getStudentListApiFun()
    },
    // 分页查询学生
    getStudentListApiFun(data) {
      this.params.currentPage = this.pages.currentPage
      this.params.pageSize = this.pages.pageSize
      this.params.bjid = this.bjid
      this.params.yhid = this.$store.state.userInfo.yhid
      this.params.xm = this.search_data.mc
      data = this.params
      let api = getStudentRoutineList
      if (this.bjlx == 2) {
        api = getStudentLisTemporarytApi
      }
      api(data).then(res => {
        if (res.result) {
          this.pages.total = res.result.total
          res.result.list.forEach((item, index) => {
            item.index = (this.pages.currentPage - 1) * this.pages.pageSize + index + 1
            if (item.xb == 1) {
              item.Gender = '男'
            } else if (item.xb == 2) {
              item.Gender = '女'
            } else if (item.xb == 9) {
              item.Gender = '未选择性别'
            } else {
              item.Gender = '未知'
            }
          })
          this.tableData = res.result.list
        }
      })
    },
    handelSearch() {
      this.pages.currentPage = 1;
      this.getStudentListApiFun()
    },
    // 点击查询
    handelSearchAll() {
      this.judgeHandelSearch()
    },
    // 判断调用哪个
    judgeHandelSearch() {
      if (this.tab_pane_index == 1) {
        this.handelSearch()
      } else if (this.tab_pane_index == 2) {
        this.$refs.group.parentSearch(this.search_data.mc);
      } else if (this.tab_pane_index == 3) {
        this.$refs.historyGroup.parentSearch(this.search_data.mc);
      } else if (this.tab_pane_index == 4) {
        console.log(this.tab_pane_index)
      }
    },
    //切换tab栏
    tabClick() {
      this.search_data.mc = '';
      this.judgeHandelSearch()
    },
    // ----------------
    // 点击新增小组
    addGroup() {
      this.$refs.group.editGroup(1);
    },
    // 随机分组
    randomGroup() {
      this.$refs.group.randomGroup();
    },


    // 查询是否可以兑换

    async queryExchange() {
      const {result} = await exchangeInquiry({
        bjid: this.$route.query.classId,
      })
      this.exchangeFlag = !!result.sfdh;
    },

    // 兑换
    async exchange() {

      const {result} = await modifyExchange({
        bjid: this.$route.query.classId,
        sfdh: this.exchangeFlag ? 0 : 1
      })
      await this.queryExchange()
    },
    // 上课
    classBegin() {
      this.$confirm("一天仅能上课一次，请谨慎操作! 如果当天已完成上下课，当日将无法再次发起。", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {

            if (this.group_num < 1) {
              this.$message.error('您还没有给学生分组，暂时无法上课')
              return false
            }
            if (!this.is_socket) {
              this.$message.error('学生平板已掉线，请重新连接')
              return false
            }

            this.suspendShow = true;
            localStorage.setItem('suspendShow', JSON.stringify(this.suspendShow));
            this.startShow = false;
            localStorage.setItem('startShow', JSON.stringify(this.startShow));
            const data = {
              bjid: this.bjid,
              bjmc: this.bjmc,
              cjr: this.yhid,
              xgr: this.yhid,
              startTime: this.$route.query.startTime,
              endTime: this.$route.query.endTime
            }
            startClassApi(data).then(res => {
              if (res.resultCode == 200) {
                this.$message.success('已上课')
                this.class_type = 1;
                const query = JSON.parse(JSON.stringify(this.$route.query));
                query.pmzt = this.class_type == 1 ? true : false;
                query.class_type = 1
                this.$router.replace({query: query})
                this.$Bus.$emit('class_change', {type: 1, bjid: this.bjid})
              } else {
                this.$message.error(res.resultDesc)
              }
            })

          })


    },
    // 暂停
    suspend() {
      this.startShow = true;
      localStorage.setItem('startShow', JSON.stringify(this.startShow));
      this.suspendShow = false;
      localStorage.setItem('suspendShow', JSON.stringify(this.suspendShow));
      this.$Bus.$emit('class_change', {type: 2, bjid: this.bjid})
      const data = {
        bjid: this.bjid,
        pmzt: 0
      }
      lockChangeApi(data).then(res => {
        this.$message.success('已暂停')
      })
    },
    //开始
    start() {
      this.startShow = false;
      localStorage.setItem('startShow', JSON.stringify(this.startShow));
      this.suspendShow = true;
      localStorage.setItem('suspendShow', JSON.stringify(this.suspendShow));
      this.$Bus.$emit('class_change', {type: 1, bjid: this.bjid})
      const data = {
        bjid: this.bjid,
        pmzt: 1
      }
      lockChangeApi(data).then(res => {
        this.$message.success('已开始')
      })
    },
    // 下课
    classEnd() {
      this.$confirm("是否确认下课? 确认后当天将无法再次上课。", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            if (!this.is_socket) {
              this.$message.error('学生平板已掉线，请重新连接')
              return false
            }
            const data = {
              bjid: this.bjid,
              bjmc: this.bjmc,
              cjr: this.yhid,
              xgr: this.yhid,
            }
            endClassApi(data).then(res => {
              this.$message.success('已下课')
              this.class_type = 2;
              const query = JSON.parse(JSON.stringify(this.$route.query));
              query.pmzt = this.class_type == 1 ? true : false;
              query.class_type = 2
              this.$router.replace({query: query})
              this.$Bus.$emit('class_change', {type: 2, bjid: this.bjid})
            })
          })
    }
  },
}
</script>
<style lang="scss" scoped>
.studentDisplay {
  height: 100%;
  position: relative;
}

.stu-search {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}

.class-box {
  height: calc(100% - 75px);

  ::v-deep  .el-tabs {
    height: 100%;
  }

  ::v-deep  .el-tabs__content {
    // background-color: #eee;
    height: calc(100% - 40px);
  }

  ::v-deep  .el-tab-pane {
    height: 100%;

    .table {
      height: 100%;

      .tea-pagination {
        margin-top: 10px;
      }
    }
  }

  ::v-deep  .stu-group {
    height: 100%;
  }
}
</style>
